var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_230)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 69C53.5538 69 69 53.5538 69 34.5C69 15.4462 53.5538 0 34.5 0C15.4462 0 0 15.4462 0 34.5C0 53.5538 15.4462 69 34.5 69ZM11.7778 31.4567C13.3674 31.4567 14.9201 31.05 15.8073 30.2367V48.7947H21.2416V22.5474H16.8424C15.9922 25.1351 14.2177 26.3921 11.556 26.3921H11.0015V31.4567H11.7778ZM24.8422 41.7708C24.8422 46.4657 28.3172 49.3492 33.8624 49.3492C39.4446 49.3492 42.9936 46.3918 42.9936 41.512C42.9936 37.7782 41.4779 35.745 38.4095 34.4511C40.9973 33.3421 42.1433 31.6046 42.1433 28.795C42.1433 24.4697 38.7792 21.9189 33.7515 21.9189C28.7239 21.9189 25.3968 24.7655 25.3968 29.1647C25.3968 32.4179 26.6906 34.4141 29.3154 35.6341C26.284 36.7061 24.8422 38.7024 24.8422 41.7708ZM33.9364 45.2458C31.8292 45.2458 30.5723 43.8779 30.5723 41.4011C30.5723 39.146 31.2377 37.8522 32.9382 36.9649L33.9364 37.2976C36.3023 38.074 37.3005 39.1091 37.3005 41.512C37.3005 43.9888 36.0436 45.2458 33.9364 45.2458ZM34.0103 32.9354C31.7922 32.196 30.7941 31.1979 30.7941 29.0907C30.7941 26.8357 31.9031 25.6897 33.7885 25.6897C35.7108 25.6897 36.7829 26.9096 36.7829 29.2016C36.7829 31.2349 36.2284 32.3809 34.8236 33.1942L34.0103 32.9354ZM52.4689 44.5803H56.5354V38.5545H62.3394V34.7468H56.5354V28.758H52.4689V34.7468H46.6649V38.5545H52.4689V44.5803Z",
    fill: "#C8B690"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.766cdaa50f2128128a221936f5aa2dab.svg";
export { ForwardRef as ReactComponent };